/**
 * RequireAuth — route guard that redirects unauthenticated users to /login.
 *
 * Reads the access token from the auth store. If absent, replaces the current
 * history entry with /login and passes the original location as `state.from`
 * so the login page can redirect back after a successful authentication.
 *
 * Usage:
 *   <Route path="/users" element={<RequireAuth><AppShell><UsersPage /></AppShell></RequireAuth>} />
 */
import { Navigate, useLocation } from 'react-router';
import { useAuthStore } from '@/store/auth.js';

interface RequireAuthProps {
  children: React.ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const accessToken = useAuthStore((s) => s.accessToken);
  const location = useLocation();

  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
